import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import UUID from "vue3-uuid";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { HB_APP, Honeybadger, HoneybadgerVue, buildHoneybadgerConfig } from "./plugins/honeybadger";

const app = createApp(App);
app.use(HoneybadgerVue, buildHoneybadgerConfig(process.env));

// Which screen the player was on. Set on every navigation rather than once,
// since an SPA otherwise reports every error under the route it booted at.
// Gated on the same key check buildHoneybadgerConfig uses, so without a key
// the plugin still installs but reports nothing, since reportData is false.
if (process.env.VUE_APP_HONEYBADGER_API_KEY) {
    router.afterEach((to) => {
        // Unnamed parameterised routes would otherwise mint one Honeybadger
        // component per record id; the URL is already on the fault, so a coarse
        // bucket loses nothing.
        const screen = to.name ? String(to.name) : "unnamed";
        Honeybadger.configure({ component: `${HB_APP}:${screen}` });
        Honeybadger.setContext({ route: screen });
    });
}

app.use(store).use(router).use(UUID).mount("#app");
